export default "__VITE_ASSET__CnNZDnvd__"